import { IconComponentStyled } from '@procurify/ui'
import styled from 'styled-components'

interface IOrderItemStatusLabelStyledProps {}

export const OrderItemStatusLabelStyled = styled.div<IOrderItemStatusLabelStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${IconComponentStyled} {
    margin-left: ${(props) => props.theme.space.xsmall};
  }
`
